module.exports = __webpack_public_path__ + "media/images/portal/landing-1-bg-570e125aeb4772f36c5d0d05233f62ea.png";